import { render } from "./QuestionForeView.vue?vue&type=template&id=3bfdf259&scoped=true&ts=true"
import script from "./QuestionForeView.vue?vue&type=script&lang=ts"
export * from "./QuestionForeView.vue?vue&type=script&lang=ts"

import "./QuestionForeView.vue?vue&type=style&index=0&id=3bfdf259&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfdf259"]])

export default __exports__